"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuestionnaireMetadata = void 0;
var _utils = require("../../../utils/utils");
var _QuestionFactory = require("./questions/QuestionFactory");
const getQuestionMetadata = function (question, selections) {
  let metadata = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!question) return;
  const currentQuestion = (0, _QuestionFactory.createQuestion)(question.type, {
    question,
    selections,
    metadata
  });
  return currentQuestion.updateMetaData();
};
const getQuestionnaireMetadata = (question, selections, answers, skipMetadata) => {
  const previousAnswer = answers[answers.length - 1];
  if (!previousAnswer) {
    return getQuestionMetadata(question, selections);
  }
  const {
    metadata: previousMetadata
  } = previousAnswer;
  if (skipMetadata) {
    return previousMetadata;
  }
  const currentMetadata = getQuestionMetadata(question, selections, (0, _utils.clone)(previousMetadata));
  const totalMetadata = {};
  for (const key in currentMetadata) {
    if (Array.isArray(previousMetadata[key])) {
      if (key === 'recommendationCategories') {
        // create copies
        const pre = [...previousMetadata[key]];
        const cur = [...currentMetadata[key]];
        const total = [];
        pre === null || pre === void 0 ? void 0 : pre.forEach(p => {
          // no need to search for priceTypes...the configuration forces only one per category
          const c = cur.find(c => c.category === p.category);
          if (c) {
            var _p$fixedOfferings, _c$fixedOfferings;
            // merge the offerings

            // first create a copy of the previous
            const fixedOfferings = [...((_p$fixedOfferings = p.fixedOfferings) !== null && _p$fixedOfferings !== void 0 ? _p$fixedOfferings : [])];
            c === null || c === void 0 ? void 0 : (_c$fixedOfferings = c.fixedOfferings) === null || _c$fixedOfferings === void 0 ? void 0 : _c$fixedOfferings.forEach(fo => {
              const preFixedOffering = fixedOfferings.find(o => o.category === fo.category);
              if (!preFixedOffering) {
                // add the new one
                fixedOfferings.push(fo);
              } else {
                // replace it with the new one
                const index = fixedOfferings.indexOf(preFixedOffering);
                fixedOfferings.splice(index, 1, fo);
              }
            });
            if (fixedOfferings.length) total.push({
              category: p.category,
              priceType: p.priceType,
              if: p.if,
              fixedOfferings
            });
            // remove it
            cur.splice(cur.indexOf(c), 1);
          } else {
            total.push(p);
          }
        });
        // now go through all the current to get the rest of them
        cur === null || cur === void 0 ? void 0 : cur.forEach(c => {
          total.push(c);
        });
        totalMetadata[key] = total;
      } else {
        totalMetadata[key] = [...previousMetadata[key], ...currentMetadata[key]];
      }
    } else if (typeof totalMetadata[key] === 'object') {
      totalMetadata[key] = {
        ...previousMetadata[key],
        ...currentMetadata[key]
      };
    } else {
      totalMetadata[key] = currentMetadata[key];
    }
  }
  return totalMetadata;
};
exports.getQuestionnaireMetadata = getQuestionnaireMetadata;